import { Phone } from "lucide-react";
import { PHONE_TEL } from "@/lib/content";

// The ministry's own logo (cross, heart and name), with a transparent background.
export const BrandLogo = ({ className = "h-16 md:h-20" }) => (
  <img src="/logo.png" alt="Military Marriages Matter!" className={`w-auto ${className}`} data-testid="brand-logo" />
);

const LINKS = [
  { href: "/#ways", label: "Ways we help" },
  { href: "/#retreats", label: "Retreats" },
  { href: "/resources", label: "Free guides" },
  { href: "/our-story", label: "Our story" },
  { href: "/#book", label: "Book" },
  { href: "/#donate", label: "Give" },
  { href: "/#contact", label: "Contact" },
];

const linkCls =
  "bg-no-repeat bg-bottom bg-[length:0%_1px] hover:bg-[length:100%_1px] transition-[background-size] duration-500 bg-gradient-to-r from-brass to-brass";

export const Header = () => (
  <header className="bg-sage text-pine sticky top-0 z-40 bg-sage/90 backdrop-blur-md" data-testid="site-header">
    <nav className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
      <a href="/#top" className="flex items-center" data-testid="nav-logo-link">
        <BrandLogo />
      </a>
      <div className="hidden md:flex gap-8 text-sm">
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} className={linkCls} data-testid={`nav-link-${l.href.replace(/[^a-z]/g, "")}`}>
            {l.label}
          </a>
        ))}
      </div>
      <a
        href={PHONE_TEL}
        className="md:hidden inline-flex items-center gap-2 rounded-full border border-pine px-4 py-2 text-sm"
        data-testid="nav-call-button-mobile"
      >
        <Phone size={14} /> Call
      </a>
    </nav>
  </header>
);
